import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  USER_FROM_TOKEN,
  USER_FROM_TOKEN_SUCCESS,
  USER_FROM_TOKEN_FAILURE,
  ADD_USER,
  ADD_USER_SUCCESS,
  ADD_USER_FAILURE,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  SEARCH_USER,
  SEARCH_USER_SUCCESS,
  SEARCH_USER_FAILURE,
  IMPORT_USERS,
  IMPORT_USERS_SUCCESS,
  IMPORT_USERS_FAILURE,
  UPDATE_USERS_BALANCE,
  UPDATE_USERS_BALANCE_SUCCESS,
  UPDATE_USERS_BALANCE_FAILURE,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  LOGOUT_USER_FAILURE
} from '../actions/userActions';

const INITIAL_STATE = {
  user: null,
  role: null,
  status: null,
  error: null,
  loading: false,
  created: {
    user: null,
    status: null,
    error: null,
    loading: false
  },
  updated: {
    user: null,
    status: null,
    error: null,
    loading: false
  },
  deleted: {
    uid: null,
    status: null,
    error: null,
    loading: false
  },
  searched: {
    users: [],
    status: null,
    error: null,
    loading: false
  },
  import: {
    log: null,
    status: null,
    error: null,
    loading: false,
  },
  updateBalance: {
    log: null,
    status: null,
    error: null,
    loading: false,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, user: null, role: null, status: 'login', error: null, loading: true };
    case LOGIN_USER_SUCCESS:
      return { ...state, user: action.payload.user, role: action.payload.role, status: 'authenticated', error: null, loading: false };
    case LOGIN_USER_FAILURE:
      return { ...state, user: null, role: null, status: 'login', error: action.payload.error, loading: false };

    case USER_FROM_TOKEN:
      return { ...state, user: null, role: null, status: 'storage', error: null, loading: true };
    case USER_FROM_TOKEN_SUCCESS:
      return { ...state, user: action.payload.user, role: action.payload.role, status: 'authenticated', error: null, loading: false };
    case USER_FROM_TOKEN_FAILURE:
      return { ...state, user: null, role: null, status: 'storage', error: action.payload.error, loading: false }

    case LOGOUT_USER:
      return { ...state, user: null, role: null, status: 'loging-out', error: null, loading: true }
    case LOGOUT_USER_SUCCESS:
      return { ...state, user: action.payload, role: null, status: 'logout', error: null, loading: false }
    case LOGOUT_USER_FAILURE:
      return { ...state, user: null, role: null, status: 'not-logout', error: action.payload.error, loading: false }

    case ADD_USER:
      return { ...state, created: { user: null, status: 'creating',  error: null, loading: true} }
    case ADD_USER_SUCCESS:
      return { ...state, created: { user: action.payload.user, status: 'created',  error: null, loading: false} }
    case ADD_USER_FAILURE:
      return { ...state, created: { user: null, status: 'not-created',  error: action.payload.error, loading: false} }

    case UPDATE_USER:
      return { ...state, updated: { user: null, status: 'updating',  error: null, loading: true} }
    case UPDATE_USER_SUCCESS:
      return { ...state, updated: { user: action.payload.user, status: 'updated',  error: null, loading: false} }
    case UPDATE_USER_FAILURE:
      return { ...state, updated: { user: null, status: 'not-updated',  error: action.payload.error, loading: false} }

    case DELETE_USER:
      return { ...state, deleted: { user: null, status: 'deleting',  error: null, loading: true} }
    case DELETE_USER_SUCCESS:
      return { ...state, deleted: { user: action.payload.uid, status: 'deleted',  error: null, loading: false} }
    case DELETE_USER_FAILURE:
      return { ...state, deleted: { user: null, status: 'not-deleted',  error: action.payload.error, loading: false} }

    case SEARCH_USER:
      return { ...state, searched: { users: [], status: 'searching',  error: null, loading: true} }
    case SEARCH_USER_SUCCESS:
      return { ...state, searched: { users: action.payload.users, status: 'search-success',  error: null, loading: false} }
    case SEARCH_USER_FAILURE:
      return { ...state, searched: { users: [], status: 'search-fail',  error: action.payload.error, loading: false} }

    case IMPORT_USERS:
      return { ...state, import: { log: null, status: 'importing', error: null, loading: true, progress: 0} }
    case IMPORT_USERS_SUCCESS:
      return { ...state, import: { log: action.payload.log, status: 'imported', error: null, loading: false, progress: 0} }
    case IMPORT_USERS_FAILURE:
      return { ...state, import: { log: null, status: 'not-imported', error: action.payload.error, loading: false, progress: 0} }

    case UPDATE_USERS_BALANCE:
      return { ...state, updateBalance: { log: null, status: 'importing', error: null, loading: true, progress: 0} }
    case UPDATE_USERS_BALANCE_SUCCESS:
      return { ...state, updateBalance: { log: action.payload.log, status: 'imported', error: null, loading: false, progress: 0} }
    case UPDATE_USERS_BALANCE_FAILURE:
      return { ...state, updateBalance: { log: null, status: 'not-imported', error: action.payload.error, loading: false, progress: 0} }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js